import { useEffect } from 'react';

import { useAppDispatch } from 'Store';
import {
  clearIsSaveCurrentUserInfoSuccess,
  saveCurrentUserInfo,
  useSelectCurrentUserInfo,
  useSelectIsSaveCurrentUserInfoSuccess
} from 'User/data';

import type { ISaveCurrentUserInfoRequest } from '@libs/models';

import { MyAccountForm } from './MyAccountForm';

type Props = {
  onClose: () => void;
};

export const MyAccountFormContainer = ({ onClose }: Readonly<Props>) => {
  const dispatch = useAppDispatch();

  const currentUserInfo = useSelectCurrentUserInfo();
  const isSaveCurrentUserInfoSuccess = useSelectIsSaveCurrentUserInfoSuccess();

  const handleSubmit = (formData: ISaveCurrentUserInfoRequest) => {
    dispatch(
      saveCurrentUserInfo({
        firstName: formData.firstName,
        lastName: formData.lastName,
        displayName: formData.displayName,
        avatarColor: formData.avatarColor,
        timezone: formData.timezone
      } as ISaveCurrentUserInfoRequest)
    );
  };

  useEffect(() => {
    dispatch(clearIsSaveCurrentUserInfoSuccess());
  }, [dispatch]);

  useEffect(() => {
    if (isSaveCurrentUserInfoSuccess) {
      const timeout = window.setTimeout(() => {
        onClose();
      }, 2000);

      return () => {
        window.clearTimeout(timeout);
      };
    }
  }, [isSaveCurrentUserInfoSuccess, onClose]);

  return (
    <MyAccountForm
      onSubmit={handleSubmit}
      email={currentUserInfo.email}
      firstName={currentUserInfo.firstName}
      lastName={currentUserInfo.lastName}
      displayName={currentUserInfo.displayName}
      avatarColor={currentUserInfo.avatarColor}
      timezone={currentUserInfo.timezone}
      isSubmitSuccess={isSaveCurrentUserInfoSuccess}
    />
  );
};
